module.exports = __webpack_public_path__ + "static/media/truck_load_automation_sample_file.19e899e3.xlsx";